import { LeftArrow } from "neetoicons";
import { Button } from "neetoui";
import { useTranslation } from "react-i18next";

import CardLayout from "components/CardLayout";
import Container from "components/Container";
import Header from "components/Header";

import { SOCIAL_MEDIA_OPTIONS } from "./constants";

const SocialMedia = ({ socialMediaProps, url, shareUrl }) => {
  const { t } = useTranslation();

  const title =
    socialMediaProps?.pageTitle ||
    socialMediaProps?.cardTitle ||
    t("neetoMolecules.shareViaLink.socialMediaShare.title");

  const description =
    socialMediaProps?.pageDescription ||
    socialMediaProps?.cardDescription ||
    t("neetoMolecules.shareViaLink.socialMediaShare.description");

  return (
    <Container className="neeto-molecules-social-share-landing-page py-8">
      <Button
        className="mb-4"
        data-testid="back-button"
        icon={LeftArrow}
        iconPosition="left"
        label={t("neetoMolecules.productEmbed.backToShare")}
        size="small"
        style="link"
        to={shareUrl}
      />
      <Header
        className="py-0"
        title={t("neetoMolecules.shareViaLink.socialMediaShare.title")}
      />
      <CardLayout
        {...{ description, title }}
        actionBlock={
          <div className="flex flex-wrap items-center gap-3">
            {Object.entries(SOCIAL_MEDIA_OPTIONS).map(
              ([key, { label, icon: Icon, generateShareUrl }]) => (
                <Button
                  {...{ label }}
                  data-testid={`social-media-button-${key}`}
                  icon={Icon}
                  iconPosition="right"
                  key={key}
                  rel="noopener noreferrer"
                  style="tertiary"
                  target="_blank"
                  href={generateShareUrl({
                    url,
                    title: socialMediaProps?.postTitle,
                  })}
                >
                  <Icon size={24} />
                </Button>
              )
            )}
          </div>
        }
      />
    </Container>
  );
};

export default SocialMedia;
